import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-51ad2294"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "section" }
const _hoisted_2 = { class: "flex-panel" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", { class: "text-center" }, "Processing results", -1))
const _hoisted_4 = {
  key: 0,
  class: "section",
  style: {"text-align":"center"}
}
const _hoisted_5 = { class: "h5" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_7 = {
  key: 1,
  class: "section",
  style: {"text-align":"center"}
}
const _hoisted_8 = { class: "h5" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_10 = {
  key: 2,
  class: "section",
  style: {"text-align":"center"}
}
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "h5" }, "You have cancelled your authorisation request.", -1))
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_13 = {
  key: 3,
  class: "section",
  style: {"text-align":"center"}
}
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "h5" }, " There was an error whilst completing your authorisation request. ", -1))
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "We will now take you back to the data recipients website.", -1))
const _hoisted_17 = [
  _hoisted_14,
  _hoisted_15,
  _hoisted_16
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Spinner = _resolveComponent("Spinner")!

  return (_openBlock(), _createElementBlock("main", null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_component_Spinner, {
          processing: _ctx.processing,
          outcome: _ctx.authorised
        }, null, 8, ["processing", "outcome"])
      ])
    ]),
    _hoisted_3,
    (
        _ctx.dataRecipient &&
        _ctx.processing === false &&
        _ctx.authorised === true &&
        _ctx.applicationStore.authorisationPromise
      )
      ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, " You have authorised data sharing with " + _toDisplayString(_ctx.dataRecipient.clientName), 1),
          _hoisted_6,
          _createElementVNode("p", null, "We will now take you back to " + _toDisplayString(_ctx.dataRecipient.clientName) + ".", 1)
        ]))
      : _createCommentVNode("", true),
    (
        _ctx.dataRecipient &&
        _ctx.processing === false &&
        _ctx.authorised === false &&
        _ctx.errorMessage === '' &&
        _ctx.applicationStore.authorisationPromise
      )
      ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
          _createElementVNode("div", _hoisted_8, " You have declined data sharing with " + _toDisplayString(_ctx.dataRecipient.clientName), 1),
          _hoisted_9,
          _createElementVNode("p", null, "We will now take you back to " + _toDisplayString(_ctx.dataRecipient.clientName) + ".", 1)
        ]))
      : (
        _ctx.dataRecipient &&
        _ctx.processing === false &&
        !_ctx.applicationStore.authorisationPromise &&
        !_ctx.errorMessage
      )
        ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
            _hoisted_11,
            _hoisted_12,
            _createElementVNode("p", null, "We will now take you back to " + _toDisplayString(_ctx.dataRecipient.clientName) + ".", 1)
          ]))
        : (_ctx.processing === false && _ctx.errorMessage)
          ? (_openBlock(), _createElementBlock("div", _hoisted_13, _hoisted_17))
          : _createCommentVNode("", true)
  ]))
}